module.exports = __webpack_public_path__ + "static/media/right.80d37618.mp3";